import React, { useState } from "react";
import PropTypes from "prop-types";

import { FaAngleDown, FaFolderOpen, FaAngleUp } from "react-icons/fa";
import { Col, Row } from "react-bootstrap";
import { useEffect } from "react";
import _ from "lodash";
import usePagePermission from "app/hooks/usePagePermission";

const PermissionItem = ({
  item,
  isCollapseAll,
  isExpandAll,
  updatePermission,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapseToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    setIsCollapsed(true);
  }, [isCollapseAll]);

  useEffect(() => {
    setIsCollapsed(false);
  }, [isExpandAll]);
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();
  //console.log({ canView, canAdd, canEdit, canDelete });
  const { id, name, childMenus, permission } = item;

  return (
    <div>
      <Row>
        <Col xs={12} md={8}>
          <Row className="menuRow">
            <Col xs={6} lg={8}>
              <div
                className={`d-flex  text-primary my-2 cursor-pointer ${
                  isCollapsed ? "collapsed" : ""
                }`}
                onClick={handleCollapseToggle}
              >
                {childMenus.length > 0 ? (
                  isCollapsed ? (
                    <FaAngleUp className="me-2 mt-1" />
                  ) : (
                    <FaAngleDown className="me-2 mt-1" />
                  )
                ) : (
                  <span style={{ marginRight: "20px" }}>
                    <FaAngleUp className="d-none" />
                  </span>
                )}
                {name}
              </div>
            </Col>
            <Col xs={6} lg={4} className="p-1">
              <div className="d-flex  text-primary my-2 cursor-pointer justify-content-end mr-1">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permission.canView"
                    checked={permission?.canView}
                    onChange={(e) => {
                      //  let updatePermissionData = _.cloneDeep(item);
                      // updatePermissionData.permission.canView =
                      //   e.target.checked;

                      updatePermission(item.id, "view", e.target.checked);
                    }}
                    disabled={!canEdit} // disable if canEdit if false
                  />
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permission.canAdd"
                    checked={permission?.canAdd}
                    onChange={(e) => {
                      // let updatePermissionData = _.cloneDeep(item);
                      // updatePermissionData.permission.canAdd = e.target.checked;
                      updatePermission(item.id, "add", e.target.checked);
                    }}
                    disabled
                  />
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permission.canEdit"
                    checked={permission?.canEdit}
                    onChange={(e) => {
                      updatePermission(item.id, "edit", e.target.checked);
                    }}
                    disabled
                  />
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permission.canDelete"
                    checked={permission?.canDelete}
                    onChange={(e) => {
                      updatePermission(item.id, "delete", e.target.checked);
                    }}
                    disabled
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      {childMenus && (
        <div className={` ${isCollapsed ? "d-none" : ""}`}>
          {childMenus.map((subitem) => (
            <Subitem
              key={subitem.id}
              subitem={subitem}
              updatePermission={updatePermission}
              isMenuView={permission?.canView}
            />
          ))}
        </div>
      )}
    </div>
  );
};

PermissionItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    childMenus: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

const Subitem = ({ subitem, updatePermission, isMenuView }) => {
  const { id, name, permission } = subitem;
  const { canView, canAdd, canEdit, canDelete } = usePagePermission();
  // console.log({ canView, canAdd, canEdit, canDelete });

  return (
    <div>
      <Row>
        <Col xs={12} md={8}>
          <Row className="menuRow">
            <Col xs={6} lg={8} className="p-1">
              <div className="d-flex pl-4">
                <FaFolderOpen className="ms-4 me-2 mt-1" />
                {name}
              </div>
            </Col>
            <Col xs={6} lg={4} className="p-1">
              <div className="d-flex  text-primary my-2 cursor-pointer justify-content-end mr-1">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permission.canView"
                    checked={permission?.canView}
                    onChange={(e) => {
                      updatePermission(id, "view", e.target.checked);
                    }}
                    disabled={!isMenuView || !canEdit} // disable if canEdit if false
                  />
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permission.canAdd"
                    checked={permission?.canAdd}
                    onChange={(e) => {
                      updatePermission(id, "add", e.target.checked);
                    }}
                    disabled={!permission?.canView || !isMenuView || !canEdit} // disable if canEdit if false
                  />
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permission.canEdit"
                    checked={permission?.canEdit}
                    onChange={(e) => {
                      updatePermission(id, "edit", e.target.checked);
                    }}
                    disabled={
                      !permission?.canView ||
                      !permission?.canAdd ||
                      !isMenuView ||
                      !canEdit
                      // disable if canEdit if false
                    }
                  />
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permission.canDelete"
                    checked={permission?.canDelete}
                    onChange={(e) => {
                      updatePermission(id, "delete", e.target.checked);
                    }}
                    disabled={
                      !permission?.canView ||
                      !permission?.canAdd ||
                      !permission?.canEdit ||
                      !isMenuView ||
                      !canEdit // disable if canEdit if false
                    }
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

Subitem.propTypes = {
  subitem: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default PermissionItem;
